module.exports = __webpack_public_path__ + "static/weekly-menu-3af11b9b54f557f77abc2afcaa915df2.png";